import React from "react";
import { Avatar } from "./Avatar";
import { useAvatarBlobUrl } from "../../helpers/useAvatarBlobUrl";
import { api } from "../../config";

/**
 * Avatar que carga la foto de un empleado via API autenticada.
 *
 * Usa useAvatarBlobUrl para fetchear los bytes via axios (con token).
 * Si no hay avatar (hasAvatar=false o el fetch falla), muestra iniciales.
 *
 * Props:
 *  - employeeId: el employee_profile_id (requerido para cargar la foto)
 *  - hasAvatar: bool (si false, no intenta fetchear)
 *  - name, size, status, style: igual que Avatar
 */
export function EmployeeAvatar({ employeeId, hasAvatar, name, size = 28, status, style }) {
  const avatarUrl = employeeId && hasAvatar
    ? `/employees/${encodeURIComponent(employeeId)}/avatar`
    : null;

  const { blobUrl } = useAvatarBlobUrl(avatarUrl, { enabled: !!avatarUrl });

  return <Avatar name={name} size={size} status={status} src={blobUrl || undefined} style={style} />;
}

export default EmployeeAvatar;
